module.exports = __webpack_public_path__ + "static/kl-cebfb955ceb2cb2a05b612eebe339adc.svg";